import { PayloadAction } from '@reduxjs/toolkit';

/**
 * Identifies the source of a page title (for prioritising and/or combining)
 */
export enum TitleSource {
  /**
   * Fixed generic title (typically determined by route)
   */
  Generic,
  /**
   * Title set by a loaded component for a specific instance (typically based on state or fetched data)
   * Takes priority over generic title
   */
  Specific,
}

export type AppState = {
  /**
   * Title for the current page (as set by different sources)
   */
  pageTitle: {
    [source in TitleSource]?: string;
  };
  /**
   * Ids of dialogs active in the app, in the order they were made active
   *
   * The last id is the currently active dialog
   *
   * Ideally, we wouldn't need to track this in the app state but we need to be able to disable hotkey hooks
   * based on active dialogs
   */
  activeDialogs: Array<string>;
};

export type SetPageTitleAction = PayloadAction<{ pageTitle: string | undefined; source: TitleSource }>;

export type ToggleDialogActiveAction = PayloadAction<{
  /**
   * The dialog to be made active or inactive
   **/
  dialogId: string;
}>;
